module.exports = __webpack_public_path__ + "static/img/floor3-lz5.0ea9668.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor3-lz5.png
// module id = PcHm
// module chunks = 1